import { createStyles } from '@mantine/core';

export const useStyles = createStyles(() => ({
  dialogContainer: {
    position: 'relative',
    width: '100%',
    maxWidth: 500,
    minHeight: 300,
    margin: '0 auto',
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));
